import * as React from 'react';
import { observer } from 'mobx-react';

import { TourItineraryDateFormView } from './tour-itinerary-date-form.view';

interface Props extends ComponentViewProps<TourItineraryDateItem> {
	mode: ControlMode;
	itinerary: TourItineraryItem;
}

@observer
export class TourItineraryDateFormController extends React.Component<Props, {}> {
	render(): React.ReactNode {
		const { model, mode, setBusy, itinerary } = this.props;

		return (
			<TourItineraryDateFormView
				mode={mode}
				model={model}
				setBusy={setBusy}
				itinerary={itinerary}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/tour-itinerary-date/form/tour-itinerary-date-form.controller.tsx